import axios from "axios";
import { API_URL } from "../config/site";
import { SITE_CONFIG } from "../config/site";

// Capa de servicio de IA: disponible si el backend está activo.
export const analyzeProcess = async (processText) => {
  const { data } = await axios.post(`${API_URL}/ai/analyze`, { process: processText });
  return data;
};

// Formulario 100% estático: FormSubmit entrega cada solicitud al correo,
// sin backend propio. Requiere una activación única (primer envío dispara
// un correo de confirmación a la bandeja del destinatario).
export const sendContact = async (payload) => {
  const { data } = await axios.post(
    `https://formsubmit.co/ajax/${SITE_CONFIG.email}`,
    {
      nombre: payload.nombre,
      empresa: payload.empresa || "—",
      correo: payload.email,
      telefono: payload.telefono || "—",
      necesidad: payload.necesidad,
      presupuesto: payload.presupuesto || "No indicado",
      inicio: payload.inicio || "No indicado",
      _subject: `Nueva solicitud web — ${payload.nombre} (${payload.empresa || "sin empresa"})`,
      _template: "table",
      _captcha: "false",
      _honey: payload.website || "",
    },
    { headers: { "Content-Type": "application/json", Accept: "application/json" }, timeout: 20000 }
  );
  const msg = String(data.message || "");
  if (msg.includes("Activation")) return { status: "activation" };
  return { status: data.success === "true" || data.success === true ? "ok" : "error", detail: msg };
};
